import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTitleDetailArticleQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String'];
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
}>;

export type GetTitleDetailArticleQuery = { __typename?: 'Query' } & {
	urlV2: { __typename?: 'Url' } & Pick<Types.Url, 'id'> & {
			node:
				| ({ __typename?: 'Article' } & Pick<Types.Article, 'id'>)
				| ({ __typename?: 'Author' } & Pick<Types.Author, 'id'>)
				| ({ __typename?: 'Bundle' } & Pick<Types.Bundle, 'id'>)
				| ({ __typename?: 'Device' } & Pick<Types.Device, 'id'>)
				| ({ __typename?: 'Episode' } & Pick<Types.Episode, 'id'>)
				| ({ __typename?: 'GenericTitleList' } & Pick<Types.GenericTitleList, 'id'>)
				| ({ __typename?: 'Genre' } & Pick<Types.Genre, 'id'>)
				| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id'> & {
							content: { __typename?: 'MovieContent' } & {
								article?: Types.Maybe<{ __typename?: 'Article' } & TitleDetailArticleFragment>;
							};
						})
				| ({ __typename?: 'MultiStepSportEvent' } & Pick<Types.MultiStepSportEvent, 'id'>)
				| ({ __typename?: 'Offer' } & Pick<Types.Offer, 'id'>)
				| ({ __typename?: 'Package' } & Pick<Types.Package, 'id'>)
				| ({ __typename?: 'Page' } & Pick<Types.Page, 'id'>)
				| ({ __typename?: 'Person' } & Pick<Types.Person, 'id'>)
				| ({ __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
							content: { __typename?: 'SeasonContent' } & {
								article?: Types.Maybe<{ __typename?: 'Article' } & TitleDetailArticleFragment>;
							};
						})
				| ({ __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
							content: { __typename?: 'ShowContent' } & {
								article?: Types.Maybe<{ __typename?: 'Article' } & TitleDetailArticleFragment>;
							};
						})
				| ({ __typename?: 'SingleStepSportEvent' } & Pick<Types.SingleStepSportEvent, 'id'>)
				| ({ __typename?: 'SportCompetitionV2' } & Pick<Types.SportCompetitionV2, 'id'>)
				| ({ __typename?: 'SportCompetitorV2' } & Pick<Types.SportCompetitorV2, 'id'>)
				| ({ __typename?: 'Url' } & Pick<Types.Url, 'id'>);
		};
};

export type TitleDetailArticleFragment = { __typename?: 'Article' } & Pick<Types.Article, 'id'> & {
		content: { __typename: 'ArticleContent' } & Pick<
			Types.ArticleContent,
			'synopsis' | 'whatToKnow' | 'whereToWatch' | 'productionNews'
		>;
	};

export const TitleDetailArticleFragmentDoc = gql`
	fragment TitleDetailArticle on Article {
		id
		content {
			__typename
			synopsis
			whatToKnow
			whereToWatch
			productionNews
		}
	}
`;
export const GetTitleDetailArticleDocument = gql`
	query GetTitleDetailArticle($fullPath: String!, $country: Country!, $language: Language!) {
		urlV2(fullPath: $fullPath) {
			id
			node {
				id
				... on MovieOrShowOrSeason {
					content(country: $country, language: $language) {
						article {
							...TitleDetailArticle
						}
					}
				}
			}
		}
	}
	${TitleDetailArticleFragmentDoc}
`;
